import { haversineMiles } from './geo.js'

export const selectPropertyById = (properties = [], id) => properties.find((property) => property.id === id)

export const selectFeaturedProperties = (properties = [], limit = 6) => properties.slice(0, limit)

export const selectAvailableCities = (properties = []) =>
  [...new Set(properties.map((property) => property.city))].sort()

export const selectPropertyTypes = (properties = []) => [
  'Any',
  ...new Set(properties.map((property) => property.propertyType)),
]

const NON_PUBLIC_STATUSES = new Set(['draft', 'suspended'])

export const filterProperties = (properties = [], filters = {}) => {
  const {
    location,
    minPrice,
    maxPrice,
    propertyType,
    propertyTypes = [],
    minBeds,
    minBaths,
    hasParking,
    hasGarden,
    hasGarage,
    tenure,
    isRetirement,
    newHome,
    buyingScheme,
    auction,
    excludeNewHome,
    excludeRetirement,
    excludeBuyingScheme,
    excludeAuction,
    maxDistance,
    originLat,
    originLng,
    statusFilters,
    includeNonPublic = false,
  } = filters
  const hasOrigin = Number.isFinite(Number(originLat)) && Number.isFinite(Number(originLng))
  const radiusMiles = maxDistance && maxDistance !== 'national' ? Number(maxDistance) : null

  return properties.reduce((acc, property) => {
    const statusCode = (property.status || '').toLowerCase()
    if (!includeNonPublic && NON_PUBLIC_STATUSES.has(statusCode)) {
      return acc
    }

    if (location) {
      const searchValue = location.trim().toLowerCase()
      const matchesLocation =
        property.location.toLowerCase().includes(searchValue) || property.city.toLowerCase().includes(searchValue)
      if (!matchesLocation) return acc
    }
    if (minPrice && property.price < Number(minPrice)) return acc
    if (maxPrice && property.price > Number(maxPrice)) return acc
    if (propertyTypes && propertyTypes.length > 0 && !propertyTypes.includes(property.propertyType)) return acc
    if (propertyType && propertyType !== 'Any' && property.propertyType !== propertyType) return acc
    if (minBeds && property.beds < Number(minBeds)) return acc
    if (minBaths && property.baths < Number(minBaths)) return acc
    if (hasParking && !property.hasParking) return acc
    if (hasGarden && !property.hasGarden) return acc
    if (hasGarage && !property.hasGarage) return acc
    if (tenure && tenure !== 'Any' && property.tenure !== tenure) return acc
    if (isRetirement && !property.isRetirement) return acc
    if (newHome && !property.isNewHome) return acc
    if (buyingScheme && !property.hasBuyingScheme) return acc
    if (auction && !property.isAuction) return acc
    if (excludeNewHome && property.isNewHome) return acc
    if (excludeRetirement && property.isRetirement) return acc
    if (excludeBuyingScheme && property.hasBuyingScheme) return acc
    if (excludeAuction && property.isAuction) return acc

    let distanceMiles = null
    if (hasOrigin && radiusMiles) {
      const propertyLat = Number(property.latitude)
      const propertyLng = Number(property.longitude)
      if (!Number.isFinite(propertyLat) || !Number.isFinite(propertyLng)) {
        return acc
      }
      distanceMiles = haversineMiles(Number(originLat), Number(originLng), propertyLat, propertyLng)
      if (distanceMiles === null) {
        return acc
      }
      if (radiusMiles && distanceMiles > radiusMiles) {
        return acc
      }
    }

    if (
      statusFilters &&
      statusFilters.length &&
      !statusFilters.some((status) => status.toLowerCase() === statusCode)
    ) {
      return acc
    }

    if (distanceMiles !== null) {
      acc.push({ ...property, distanceMiles })
    } else {
      acc.push(property)
    }
    return acc
  }, [])
}
